import { useQuery } from '@apollo/client';
import { withPriceSeperator } from '@flight-workspace/common-client/src/util/number';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from './index.module.scss';
import GET_RECOMMEND_BY_THEME from './recommendByTheme.gql';

const cx = classNames.bind(styles);

interface IRecommendTheme {
  themeId: number;
  themeName: string;
  themeImage: string;
  fare: number;
  departureDate: string;
}

interface IData {
  recommendByTheme: IRecommendTheme[];
}

const MIN_COUNT = 4;

function getMonthFrom(ymd: string) {
  const simpleDateRegex = /(\d{4}).?(\d{2}).?(\d{2}).?/;

  const result = simpleDateRegex.exec(ymd);

  const monthIndex = 2;
  return result ? `${result[monthIndex]}` : '??';
}

function Theme() {
  const { error, data } = useQuery<IData>(GET_RECOMMEND_BY_THEME, {
    variables: { recommendOnly: true },
  });

  if (error || !data?.recommendByTheme?.length) return null;

  const count = data.recommendByTheme.length;
  const endIndex =
    count <= MIN_COUNT ? count : Math.floor(count / MIN_COUNT) * MIN_COUNT;

  return (
    <div className={cx('Theme')}>
      <div className={cx('inner')}>
        <h3 className={cx('title')}>테마별 여행지</h3>
        <ul className={cx('list')}>
          {data.recommendByTheme
            .slice(0, endIndex)
            .map(
              ({ themeId, themeName, themeImage, fare, departureDate }, i) => (
                <li key={i} className={cx('item')}>
                  <Link
                    className={cx('anchor')}
                    href={`/flights/everywhere/monthly/SEL?theme=${themeId}`}
                    data-event-nlog="click"
                    data-event-area-code={`mai.theme${i + 1}`}
                  >
                    <figure className={cx('thumb')}>
                      <img
                        className={cx('img')}
                        src={themeImage}
                        alt={themeName}
                      />
                    </figure>
                    <i className={cx('name')}>{`#${themeName}`}</i>
                    <div className={cx('price')}>
                      <b className={cx('amount')}>
                        {withPriceSeperator(fare)}
                        원~
                      </b>
                      <i className={cx('base')}>{`${getMonthFrom(
                        departureDate,
                      )}월 출발`}</i>
                    </div>
                  </Link>
                </li>
              ),
            )}
        </ul>
        <Link
          className={cx('more')}
          href="/flights/everywhere/monthly/SEL"
          data-event-nlog="click"
          data-event-area-code="mai.thememore"
        >
          추천 항공권 더보기
        </Link>
      </div>
    </div>
  );
}

export default Theme;
